module.exports = __webpack_public_path__ + "img/carve_rule_top.8289885a.png";